import { prepareDataForDropdown } from '../../../../../components/organisms/Filters/utils';
import { Field_Keys } from '../../../../../constants';
import useFetchData from '../../../../../hooks/fetchHook';
import { cloneDeep } from '../../../../../lib/js';
import { DC, staticOptions } from '../controllers/variables';

export const useGetFilters = ({ ignore }) => {
  const [
    { data = staticOptions, isLoading = true, isError, error },
    _,
    refetchFilters,
  ] = useFetchData('office_support_tickets/filters', {
    formatter,
    ignore,
  });

  return {
    data,
    isLoading,
    isError,
    error,
    refetchFilters,
  };
};

export const formatter = data => {
  const { brands } = data;

  const newOps = cloneDeep(staticOptions);

  newOps[DC.CUSTOMER] = prepareDataForDropdown(
    brands,
    Field_Keys.SUPPORT_TICKET.BRAND_NAME,
    Field_Keys.SUPPORT_TICKET.BRAND_ID
    // {
    //   sectionTitle: 'Brands',
    //   bulkSelectableTags: [
    //     {
    //       column: 'is_contracted',
    //       columnValue: [1, true],
    //       selectableByValue: productBrandIsContracted,
    //     },
    //     {
    //       column: 'is_contracted',
    //       columnValue: [0, false, null, undefined],
    //       selectableByValue: productBrandIsNotContracted,
    //     },
    //   ],
    //   customLabel: item =>
    //     withContractedLabel(item, {
    //       contractedKey: 'is_contracted',
    //       labelKey: 'brand_name',
    //     }),
    // }
  );

  return newOps;
};
